import {ATIVAR_ITINERARIO_EM_LOTE, INATIVAR_ITINERARIO_EM_LOTE, LIMPAR_RESULTADO_ATIVACAO_ITINERARIO_EM_LOTE} from '../../actions/types'

const initialState = {
    resultadoAtivacaoItinerarioEmLote: null
};

export default function reducerAtivacaoItinerarioEmLote (state = {}, action = initialState) {
  switch (action.type) {
    case ATIVAR_ITINERARIO_EM_LOTE: 
        return  { 
            ...state,
            resultadoAtivacaoItinerarioEmLote: action.payload.data
        }
    case INATIVAR_ITINERARIO_EM_LOTE:
        return  { 
                ...state,
                resultadoAtivacaoItinerarioEmLote: action.payload.data
        }        
    case LIMPAR_RESULTADO_ATIVACAO_ITINERARIO_EM_LOTE:
        return { 
            ...state,
            resultadoAtivacaoItinerarioEmLote: null
        }           
    default: {
      return state
    }
  }
}
